import { css, utilities } from "@creditas/stylitas"

export const customTypography = ({ variant, theme }) => css`
  ${variant === "h2" && utilities.typography.h4(theme)};
`
